export default __webpack_public_path__ + "static/media/result-activity.c5e74ae9.svg";